<layout-base
  #base
  sideNavMode="over"
  [containerTheme]="containerTheme"
  [footerTheme]="footerTheme"
  [sideRightTheme]="sideRightTheme()"
  [sideLeftTheme]="sideLeftTheme()"
  [alwaysShowToggle]="true"
  [openSideNav]="false"
  [openRightSideNav]="rightOpened()"
  [openLeftSideNav]="leftOpened()"
  (openRightSideNavChange)="rightMenuChange($event)"
  (openLeftSideNavChange)="leftMenuChange($event)">
  <div progresscontent>
    <ng-progress ngProgressRouter class="progress-bar" />
  </div>
  <!-- MENU -->
  <div sidenavheader class="side-header">
    <div class="container mx-auto px-4 h-full">
      <div class="flex mx-2 items-center justify-between h-full">
        @let info = siteInfo();
        <button (click)="goToSiteHome()">
          @if (info.logo) {
            <img [src]="info.logo" [alt]="info.name" class="ms-4 h-10" />
          } @else {
            <span>{{ info.name }}</span>
          }
        </button>
        <button
          class="justify-self-end"
          type="button"
          mat-icon-button
          aria-label="Ocultar menu"
          (click)="closeLeftMenu()">
          <mat-icon svgIcon="close"></mat-icon>
        </button>
      </div>
    </div>
  </div>
  <div sidenavmenuleft class="side-body">
    @defer (when leftOpened()) {
      <ul class="mt-6 space-y-1">
        <!-- @for (item of sideNavMenuLeftMenuItems(); track $index) {
          <store-side-menu-item [item]="item"></store-side-menu-item>
        } -->
        @for (item of sideNavMenuLeftMenuItems(); track $index) {
          <!-- ACTUALIZADO: Pasamos los inputs y escuchamos el evento itemClicked -->
          <store-side-menu-item
            [item]="item"
            [selectedCategoryHandles]="selectedCategoryHandles()"
            (itemClicked)="onSideMenuItemClicked($event)">
          </store-side-menu-item>
        }
      </ul>
    }
  </div>
  <div sidenavmenuright class="sideright-body p-3">
    <!-- SHOPPING CART HERE-->
    @defer (when rightOpened()) {
      <app-shopping-cart-mjs
        (closeCart)="rightMenuChange(false)"
        (checkout)="goCheckout()"></app-shopping-cart-mjs>
    } @placeholder {
      <div class="w-full h-screen p-8 flex justify-center items-center">
        <store-fullscreen-loader [fullscreen]="false" />
      </div>
    }
  </div>
  <!-- CONTENT AREA -->
  <div headercontent>
    @if (announcementBarConfig() && announcements().length > 0) {
      <edt-announcement-bar
        [messages]="announcements()"
        [duration]="announcementBarConfig()!.announcementDuration"
        [fadeInDuration]="announcementBarConfig()!.fadeInDuration"
        [fadeOutDuration]="announcementBarConfig()!.fadeOutDuration"
        [actionButtonsCss]="announcementBarConfig()!.actionButtonsCss"
        [barCss]="announcementBarConfig()!.barCss"
        [containerCss]="announcementBarConfig()!.containerCss"
        [contentCss]="announcementBarConfig()!.contentCss"
        [progressCss]="announcementBarConfig()!.progressCss"
        [progressSeparatorsCss]="
          announcementBarConfig()!.progressSeparatorsCss
        "></edt-announcement-bar>
    }
    <store-header [canShowSearch]="showSearch()" [logoImg]="''" />
  </div>

  <div maincontent>
    <store-horizontal-menu-2
      horizontalMenuContainerCssClass="hidden md:block shadow-sm py-2 px-2 border-y border-neutral-200"
      horizontalMenuContentCssClass="flex items-center gap-2 text-sm"
      menuItemCssClass="hover:bg-[var(--mat-sys-secondary)] hover:!text-[var(--mat-sys-on-secondary)] rounded-xl px-4 py-2 text-[var(--mat-sys-on-surface)]"
      [menuItems]="horizontalMenuItems()"
      (optionLinkSelected)="onOptionLinkSelected($event)" />
    <div class="px-6 py-3">
      <breadcrumbs
        separatorType="text"
        separator="/"
        firstItemCssClass="mx-1 text-gray-500 hover:text-[var(--mat-sys-primary)]"
        lastItemCssClass="mx-1 text-gray-500 hover:text-[var(--mat-sys-primary)]" />
    </div>
    <router-outlet [routerOutletData]="base.sidenavContentRef()" />
  </div>
  @if (footerComponentTheme(); as footerComponentTheme) {
    <edt-footer
      footercontent
      [linkStyles]="footerComponentTheme?.styles?.link_styles ?? ''"
      [headerStyles]="footerComponentTheme?.styles?.header_styles ?? ''"
      [socialStyle]="footerComponentTheme?.styles?.social_styles ?? ''"
      [footNoteStyle]="footerComponentTheme?.styles?.foot_note_styles ?? ''"
      [footNote]="footerComponentTheme?.foot_note ?? ''"
      [links]="footerComponentTheme?.links ?? []"
      [secondaryLinks]="footerComponentTheme?.secondary_links ?? []"
      [socialLinks]="footerComponentTheme?.social_links ?? []"
      [siteInfo]="footerComponentTheme.site_info"
      [helpButton]="footerComponentTheme.help_button" />
  }
</layout-base>
